import { createContext } from 'react';
import { defineAbility } from '@casl/ability';
// import { createContextualCan } from '@casl/react';

export const defaultAbility = defineAbility(() => null);
export const AbilityContext = createContext(defaultAbility);
// export const Can = createContextualCan(AbilityContext.Consumer);

export const Subjects = {
  PAGE_EVENTS: 'PAGE_EVENTS',
  PAGE_EVENT_CREATE: 'PAGE_EVENT_CREATE',
  PAGE_EVENT_EDIT: 'PAGE_EVENT_EDIT',
  PAGE_EVENT_COMPLETE: 'PAGE_EVENT_COMPLETE',
  PAGE_UPCOMING_SESSIONS: 'PAGE_UPCOMING_SESSIONS',
  PAGE_PAST_SESSIONS: 'PAGE_PAST_SESSIONS',
  PAGE_SESSION_CREATE: 'PAGE_SESSION_CREATE',
  PAGE_SESSION_DETAILS: 'PAGE_SESSION_DETAILS',
  PAGE_SESSION_EDIT: 'PAGE_SESSION_EDIT',
  PAGE_EVENT_DETAILS: 'PAGE_EVENT_DETAILS',
  PAGE_ACTIVITIES: 'PAGE_ACTIVITIES',
  PAGE_PROFILE: 'PAGE_PROFILE',
  PAGE_CHANGE_PASSWORD: 'PAGE_CHANGE_PASSWORD',
  EVENT: 'EVENT',
  EVENT_DETAILS: 'EVENT_DETAILS',
  SESSION: 'SESSION',
  SESSION_DETAILS: 'SESSION_DETAILS',
  COMPLETED_SESSION: 'COMPLETED_SESSION',
  PARTICIPANT: 'PARTICIPANT',
  DEMOGRAPHICS: 'DEMOGRAPHICS',
  YOUTH: 'YOUTH',
  ADULT: 'ADULT',
  SESSION_COLLABORATOR: 'SESSION_COLLABORATOR',
  EVENT_FLYER: 'EVENT_FLYER',
  EVENT_COLLABORATOR: 'EVENT_COLLABORATOR',
  EVENTS: 'EVENTS',
  OBSERVATION: 'OBSERVATION',
};
